import * as types from "./dokumenKerjasama.actionTypes";
import { action, createAsyncAction } from "typesafe-actions";
import { ErrorResponse } from "../../interfaces/ErrorResponse";
import { DokumenKerjasama, DokumenKerjasamaRequest, NomorIndukDetail } from "../../interfaces/DokumenKerjasama";
import { DokumenKerjasamaListRequest, DokumenKerjasamaCreateResponse, DokumenKerjasamaListResponse, DokumenKerjasamaUpdateResponse, DokumenKerjasamaDetailRequest, DokumenKerjasamaDetailResponse } from "./types";
import { DepartmentRequest } from "../../interfaces/Department";
import { PartnerRequest } from "../../interfaces/Partner";
import { BentukKerjasama } from "../../interfaces/BentukKerjasama";
import { JenisDokumen } from "../../interfaces/JenisDokumen";
import { StatusKerjasama } from "../../interfaces/StatusKerjasama";
import { Employee } from "../../interfaces/Employee";
import moment from "moment";

export const selectDokumenKerjasama = (dokumenKerjasama: DokumenKerjasama | null) => action(types.SELECT_DOKUMEN_KERJASAMA, { dokumenKerjasama });

export const updateJudulDokumen = (value: string) => action(types.UPDATE_JUDUL_DOKUMEN, { value });
export const updateNomorDokumen = (value: string) => action(types.UPDATE_NOMOR_DOKUMEN, { value });
export const updateNomorDokumenPt = (value: string) => action(types.UPDATE_NOMOR_DOKUMEN_PT, { value });
export const updateDeskripsi = (value: string) => action(types.UPDATE_DESKRIPSI, { value });
export const updateTanggalMulai = (value: string) => action(types.UPDATE_TANGGAL_MULAI, { value });
export const updateTanggalSelesai = (value: string) => action(types.UPDATE_TANGGAL_SELESAI, { value });
export const deleteFile = () => action(types.DELETE_FILE, {});
export const updateFile = (file: File | null) => action(types.UPDATE_FILE, { file });

export const updatePicUMN = (newId: string, newDetail: Employee) => action(types.UPDATE_PIC_UMN, { newId, newDetail });
export const updateStatus = (newId: number, newDetail: StatusKerjasama) => action(types.UPDATE_STATUS, { newId, newDetail });
export const updateNomorInduk = (newId: number, newDetail: NomorIndukDetail) => action(types.UPDATE_NOMOR_DOKUMEN_INDUK, { newId, newDetail });
export const updateJenisDokumen = (newId: number, newDetail: JenisDokumen) => action(types.UPDATE_JENIS_DOKUMEN, { newId, newDetail });

export const updateAnggota = (items: string) => action(types.UPDATE_ANGGOTA, { items });
export const updatePartner = (newIds: number[], newDetail: PartnerRequest[]) => action(types.UPDATE_PARTNER, { newIds, newDetail });
export const updatePelaksana = (newIds: string[], newDetail: DepartmentRequest[]) => action(types.UPDATE_PELAKSANA, { newIds, newDetail });
export const updateBentukKerjasama = (newIds: number[], newDetail: BentukKerjasama[]) => action(types.UPDATE_BENTUK_KERJASAMA, { newIds, newDetail });

export const initializeCreateDokumenKerjasama = () => {
  const defaultDepartment: DepartmentRequest = {
    DEPT_ID: '0000000053',
    DEPT_NAME: 'RELATIONS & COOPERATIONS DEPARTMENT'
  }
  
  const dokumenKerjasama: DokumenKerjasamaRequest = {
    DOK_ID: 0,
    CO_ID: [],
    KERMA_ID: [],
    DEPT_ID: [defaultDepartment.DEPT_ID],
    DOK_NAMA: '',
    DOK_NOMOR: '',
    DOK_DESCR: '',
    DOK_JENIS_ID: 0,
    DOK_NOMOR_INDUK: 0,
    DOK_NOMOR_PT: "",
    EMP_ID: "",
    DOK_TTD_ID: 0,
    DOK_JUDUL_KERJASAMA: '',
    PERIODE_AWAL: moment(new Date()).format('YYYY-MM-DD'),
    PERIODE_AKHIR: moment(new Date()).format('YYYY-MM-DD'),
    STATUS_ID: 0,
    UPDATED_AT: moment(new Date()).format('YYYY-MM-DD'),
    CREATED_BY: '',
    DOK_FILE_NAME: '',
    ANGGOTA: '',
    DOK_DETAIL: null,
    EMP_DETAIL: null,
    CO_DETAIL: [],
    PELAKSANA_KERJASAMA: [{...defaultDepartment}],
    BENTUK_KERJASAMA: [],
    DOK_JENIS_DETAIL: null,
    STATUS_DETAIL: null
  }
  return action(types.INITIALIZE_CREATE_DOKUMEN_KERJASAMA, { dokumenKerjasama })
}

export const getDokumenKerjasamaAsync = createAsyncAction(
  types.GET_DOKUMEN_KERJASAMA_REQUEST,
  types.GET_DOKUMEN_KERJASAMA_SUCCESS,
  types.GET_DOKUMEN_KERJASAMA_FAILURE
)<DokumenKerjasamaListRequest, DokumenKerjasamaListResponse, ErrorResponse>();

export const updateDokumenKerjasamaAsync = createAsyncAction(
  types.UPDATE_DOKUMEN_KERJASAMA_REQUEST,
  types.UPDATE_DOKUMEN_KERJASAMA_SUCCESS,
  types.UPDATE_DOKUMEN_KERJASAMA_FAILURE
)<DokumenKerjasamaRequest, DokumenKerjasamaUpdateResponse, ErrorResponse>();

export const getDetailDokumenKerjasamaAsync = createAsyncAction(
  types.GET_DETAIL_DOKUMEN_KERJASAMA_REQUEST,
  types.GET_DETAIL_DOKUMEN_KERJASAMA_SUCCESS,
  types.GET_DETAIL_DOKUMEN_KERJASAMA_FAILURE
)<DokumenKerjasamaDetailRequest, DokumenKerjasamaDetailResponse, ErrorResponse>();

export const createDokumenKerjasamaAsync = createAsyncAction(
  types.CREATE_DOKUMEN_KERJASAMA_REQUEST,
  types.CREATE_DOKUMEN_KERJASAMA_SUCCESS,
  types.CREATE_DOKUMEN_KERJASAMA_FAILURE
)<DokumenKerjasamaRequest, DokumenKerjasamaCreateResponse, ErrorResponse>();
